// export const API_URL = "http://192.168.0.13:8200/api/v1";
export const API_URL = "http://18.223.229.211/api/v1";

export default API_URL;
